export default [


    {
        path: '/users/list',
        name: 'users-user-list',
        component: () => import('@/views/apps/user/views/List.vue'),
        meta: {
            resource: 'user',
            action: 'read',
            pageTitle: 'Пользователи',
            breadcrumb: [
                {
                  text: 'Список пользователей',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/users/view/:id',
        name: 'users-user-view',
        component: () => import('@/views/apps/user/views/Details.vue'),
        meta: {
            resource: 'user',
            action: 'read',
            pageTitle: 'Пользователи',
            breadcrumb: [
                {
                  text: 'Список пользователей',
                  to: { name: 'users-user-list' }
                },
                {
                  text: 'Детальная информация о пользователе',
                    active: true
                },
            ],
        },
    },
]
